export default [
    {
        path: '/avaliacoes',
        view: 'avaliacoes/Index',
        name: 'Avaliações',
        permissions: ['ADMINISTRADOR', 'GESTOR', 'AUDITOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Avaliações',
                disabled: true,
                exact: true,
                to: '/avaliacoes',
            },
        ],
    },
    {
        path: '/avaliacoes/novo',
        view: 'avaliacoes/New',
        name: 'Cadastrar Avaliação',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Avaliações',
                disabled: false,
                exact: true,
                to: '/avaliacoes',
            },
            {
                text: 'Novo',
                disabled: true,
                exact: true,
                to: '/avaliacoes/novo',
            }
        ],
    },
    {
        path: '/avaliacoes/editar/:id',
        view: 'avaliacoes/Edit',
        name: 'Edição de Avaliação',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Avaliações',
                disabled: false,
                exact: true,
                to: '/avaliacoes',
            },
            {
                text: 'Editar',
                disabled: true,
                exact: true,
                to: '/avaliacoes/editar/:id',
            }
        ],
    },
    {
        path: '/avaliacoes/visualizar/:id',
        view: 'avaliacoes/View',
        name: 'Visualização de Avaliação',
        permissions: ['ADMINISTRADOR', 'GESTOR', 'AUDITOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Avaliações',
                disabled: false,
                exact: true,
                to: '/avaliacoes',
            },
            {
                text: 'Visulização',
                disabled: true,
                exact: true,
                to: '/avaliacoes/visualizar/:id',
            }
        ],
    },
    {
        path: '/avaliacoes/excluir',
        permissions: ['ADMINISTRADOR', 'GESTOR']
    },
    {
        path: '/avaliacoes/processamento',
        permissions: ['ADMINISTRADOR', 'GESTOR']
    }
];
